import { formatAmount } from "@/lib/utils";

/**
 * Реферальний баланс у мінусі (owner 2026-10-22): за оплату запрошеного друга
 * банк повернув гроші (чарджбек), і нараховані за неї реферальні знято —
 * навіть якщо їх уже виведено. Поки баланс у мінусі, вивести й обміняти не
 * можна, нові нарахування за друзів спершу гасять мінус.
 *
 * ⚠️ Та сама фраза живе на сервері — `services/referral_clawback.py`
 * (`referral_debt_text`): її показує API, коли людина все-таки тисне
 * «Вивести» чи «Обміняти». Правиш тут — правиш і там
 * (`tests/test_referral_clawback_1022.py` звіряє обидві).
 */

/** `-1250` → `−1 250 ₴`: справжній мінус і нерозривний пробіл перед гривнею. */
export function formatUahSigned(value: number): string {
  return `${value < 0 ? "−" : ""}${formatAmount(Math.abs(value))} ₴`;
}

export function referralDebtText(balance: number): string {
  return (
    "Реферальний баланс у мінусі через повернення коштів за оплату " +
    "запрошеного тобою друга: банк повернув йому гроші за підписку, тому " +
    "реферальні, нараховані за цю оплату, знято. Зараз на балансі " +
    formatUahSigned(balance) +
    ". Поки баланс у мінусі, вивести гроші на картку чи " +
    "обміняти їх на підписку не можна — нові нарахування за друзів спершу " +
    "покриють мінус."
  );
}
